<div class="ov-flow open-reporting theme-inner"
     [ngClass]="{'open-reporting': selectedTab === 'Open Reporting', 'stop-work-authority': selectedTab === 'Stop Work Authority', 'no-corruption': selectedTab === 'No Corruption', 'safe-harbour': selectedTab === 'Safe Harbour'}">
     <div class="bg-colour">
          <ion-skeleton-text *ngIf="!isFrontImageLoaded || (hasBackImage && !isBackImageLoaded)" animated="true"
               class="img-skelton"></ion-skeleton-text>
          <ng-container>
               <img *ngIf="selectedTab === 'Open Reporting'" (load)="onImageLoad('front')"
                    [class.hide]="!isFrontImageLoaded" src="../assets/img/Open-reporting-front.jpg"
                    alt="Open Reporting" />

               <img *ngIf="selectedTab === 'Open Reporting'" (load)="onImageLoad('back')"
                    [class.hide]="!isBackImageLoaded" src="../assets/img/Open-reporting-back.jpg"
                    alt="Open Reporting" />

               <img *ngIf="selectedTab === 'Stop Work Authority'" (load)="onImageLoad('front')"
                    [class.hide]="!isFrontImageLoaded" src="../assets/img/Stop-work-front.jpg"
                    alt="Stop Work Authority" />

               <img *ngIf="selectedTab === 'Stop Work Authority'" (load)="onImageLoad('back')"
                    [class.hide]="!isBackImageLoaded" src="../assets/img/Stop-work-back.jpg"
                    alt="Stop Work Authority" />

               <ng-container *ngIf="selectedTab === 'No Corruption'">
                    <img (load)="onImageLoad('front')" [class.hide]="!isFrontImageLoaded"
                         src="../assets/img/No-Corruption.jpg" alt="No Corruption - MACN incident reporting" />
                    <p class="reporting-url">
                         <a href="#" (click)="openNoCorruptionReportingUrl($event)">
                              <svg class="external-link-icon" viewBox="0 0 24 24" width="16" height="24"
                                   fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                   stroke-linejoin="round" aria-hidden="true">
                                   <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                   <polyline points="15 3 21 3 21 9" />
                                   <line x1="10" y1="14" x2="21" y2="3" />
                              </svg>
                              <span>{{ noCorruptionReportingUrl }}</span>
                         </a>
                    </p>
               </ng-container>

               <pinch-zoom class="full-screen"
                    *ngIf="selectedTab === 'Safe Harbour' && !isDesktop; else safeHarbourDesktop">
                    <img (load)="onImageLoad('front')" [class.hide]="!isFrontImageLoaded"
                         src="../assets/img/Safe-Harbour.jpg" />
               </pinch-zoom>

               <ng-template #safeHarbourDesktop>
                    <img *ngIf="selectedTab === 'Safe Harbour'" (load)="onImageLoad('front')"
                         [class.hide]="!isFrontImageLoaded" src="../assets/img/Safe-Harbour.jpg" alt="Safe Harbour" />
               </ng-template>
          </ng-container>
     </div>
</div>